"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropTarget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var faArrowUp_1 = require("@fortawesome/pro-solid-svg-icons/faArrowUp");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var utils_1 = require("utils");
var CONTAINER_STYLES = 'flex flex-col text-center h-full font-bold text-primary font-body p-2 w-full';
var ICON_WRAPPER_STYLES = 'text-xl rounded-full h-10 w-10 text-center mx-auto mt-auto flex';
var ICON_STYLES = 'm-auto';
var ACTIVE_STYLES = 'bg-white text-actionable border-2 border-actionable';
var INACTIVE_STYLES = 'bg-actionable text-white border-2 border-transparent';
var LABEL_STYLES = 'mx-auto mt-0 mb-auto';
var ACTIVE_LABEL_STYLES = 'text-actionable';
var DropTarget = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "Drag 'n' drop some files here, or click to select files" : _b, active = _a.active;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, utils_1.concatStyles)([CONTAINER_STYLES, active ? ACTIVE_STYLES : '']) }, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: (0, utils_1.concatStyles)([
                    ICON_WRAPPER_STYLES,
                    active ? ACTIVE_STYLES : INACTIVE_STYLES,
                ]) }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faArrowUp_1.faArrowUp, className: ICON_STYLES }, void 0) }), void 0), (0, jsx_runtime_1.jsx)("p", __assign({ className: (0, utils_1.concatStyles)([
                    LABEL_STYLES,
                    active ? ACTIVE_LABEL_STYLES : '',
                ]) }, { children: label }), void 0)] }), void 0));
};
exports.DropTarget = DropTarget;
